import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import {
    COOKIES_CONDITIONS_ID,
    GDPR_CONDITIONS_ID,
    MARKETING_CONDITIONS_ID,
} from '@components/BusinessConditions/BusinessConditions';
import useScrollToSection from '@hooks/useScrollToSection';
import { ROUTES, getBaseUrl } from '../../constants';
import { Wrapper } from './GdprConditions.elements';

export interface GdprConditionsProps {}

const GdprConditionsTemplate: FC<GdprConditionsProps> = () => {
    useScrollToSection('marketing', 'marketing-sekcia');
    useScrollToSection('cookies', 'cookies-sekcia');

    return (
        <Wrapper>
            <span className="title" id={`${GDPR_CONDITIONS_ID}-sekcia`}>
                ZÁSADY OCHRANY OSOBNÝCH ÚDAJOV
            </span>
            <span className="subTitle">v súlade s nariadením „GDPR“ účinným od 25. 5. 2018</span>
            <p>
                <strong>Vážení používatelia,</strong>
            </p>
            <p>
                <strong>tieto zásady ochrany osobných údajov sa vzťahujú na vás</strong> – používateľov našich služieb
                prevádzkovaných na našich jednotlivých online weboch
            </p>
            <p className="section">
                <a href="https://www.epi.sk" target="_blank" rel="noreferrer">
                    www.epi.sk,
                </a>
                <a href="https://www.danovecentrum.sk" target="_blank" rel="noreferrer">
                    www.danovecentrum.sk,
                </a>

                <a href="https://www.mzdovecentrum.sk" target="_blank" rel="noreferrer">
                    www.mzdovecentrum.sk,
                </a>

                <a href="https://www.vssr.sk" target="_blank" rel="noreferrer">
                    www.vssr.sk,
                </a>

                <a href="https://www.eurokodex.sk" target="_blank" rel="noreferrer">
                    www.eurokodex.sk,
                </a>

                <a href="https://www.profivzdelavanie.sk" target="_blank" rel="noreferrer">
                    www.profivzdelavanie.sk,
                </a>

                <a href="https://www.bezpecnostvpraxi.sk" target="_blank" rel="noreferrer">
                    www.bezpecnostvpraxi.sk,
                </a>

                <a href="https://www.pp.sk" target="_blank" rel="noreferrer">
                    www.pp.sk,
                </a>

                <a href="https://www.zakonypreludi.sk" target="_blank" rel="noreferrer">
                    www.zakonypreludi.sk,
                </a>

                <a href="https://www.zakon.sk" target="_blank" rel="noreferrer">
                    www.zakon.sk,
                </a>
            </p>
            <p>školeniach, ako aj pre čitateľov našich tlačených titulov, pokiaľ spracúvame ich osobné údaje.</p>
            <p>
                Pri poskytovaní našich služieb a produktov ako aj pri ich inovácii vždy berieme na zreteľ vaše súkromie.
                Uvedomujeme si svoj záväzok voči svojim užívateľom. Plne si uvedomujeme naše záväzky voči vám prameniace
                z požiadaviek právnych predpisov regulujúcich vaše súkromie a ochranu vašich osobných údajov.{' '}
                <strong>K ochrane vašich osobných údajov pristupujeme s rešpektom a zodpovedne.</strong> Preto
                spolupracujeme s odborníkmi z rôznych oblastí napr. z oblasti právnej, bezpečnostnej, IT, aby sme sa
                ubezpečili, že žiadne rozhodnutie sa neprijme bez rešpektovania súkromia.
            </p>
            <p>
                V rámci našich služieb môžete spravovať svoje súkromie rôznym spôsobom. Zároveň máte vždy
                <strong>možnosť využiť svoje práva</strong> vyplývajúce z Nariadenia Európskeho parlamentu a Rady (EÚ)
                2016/679 z 27. apríla 2016 o ochrane fyzických osôb pri spracúvaní osobných údajov a o voľnom pohybe
                takýchto údajov, ktorým sa ruší smernica 95/46/ES (všeobecné nariadenie o ochrane údajov) („Nariadenie“)
                a zákona č. 18/2018 Z. z. o ochrane osobných údajov a o zmene a doplnení niektorých zákonov („Zákon“)
            </p>
            <p>
                <strong>Účelom týchto zásad ochrany osobných údajov je poskytnutie informácii</strong> o tom, kto,
                prečo, ako spracúva vaše osobné údaje, komu sú vaše osobné údaje poskytované, aké máte práva vyplývajúce
                z Nariadenia a Zákona, ako ich môžete uplatniť.
            </p>
            <span className="sectionTitle">Kto sme - prevádzkovateľ</span>
            <p>
                <strong>Vaše osobné údaje sú spracúvané a chránené</strong> spoločnosťou Poradca podnikateľa, spol. s r.
                o., Martina Rázusa 23A, 010 01 Žilina, IČO: 31 592 503. Z pohľadu Zákona a Nariadenia
                <strong> máme postavenie prevádzkovateľa.</strong>
            </p>
            <span className="sectionTitle">Aké typy informácii o vás zhromažďujeme?</span>
            <p>
                Preto, aby sme vám mohli poskytnúť naše služby ako aj preto, aby sme mohli naše služby neustále
                zlepšovať, zhromažďujeme o vás informácie. Informácie, ktoré o vás zhromažďujeme, a spôsob ich využitia
                závisí od toho, akú našu konkrétnu službu používate a akým spôsobom spravujete ovládanie svojej ochrany
                súkromia u nás. V zásade je možné informácie, ktoré o vás spracúvame rozčleniť nasledovne:
            </p>
            <p>
                Informácie, ktorá nám odovzdávate v priamej súvislosti s konkrétnou poskytovanou službou alebo
                v súvislosti s organizovanou súťažou a to:
            </p>
            <ul>
                <li>
                    informácie potrebné k vytvoreniu účtu za účelom prístupu k službám prevádzkovaným na našich online
                    weboch,
                </li>
                <li>
                    informácie, ktoré sú potrebné na zapojenie sa do súťaže, jej spravovanie a vyhodnotenie súťaže,
                    ktorú organizujeme – napríklad meno, priezvisko, bydlisko, fotografia,
                </li>
                <li>
                    informácie, ktoré poskytujete pri používaní zvolenej služby – napríklad fotografie, príspevky,
                    komentáre,
                </li>
                <li>
                    informácie poskytované pri našich platených službách – platobné informácie, napríklad číslo
                    platobnej karty alebo iné finančné informácie,
                </li>
                <li>
                    informácie poskytované pri účasti na našich propagačných akciách a súťažiach, ak sa rozhodnete na
                    nich participovať,
                </li>
                <li>
                    informácie súvisiace s vašimi dopytmi riešenými našou zákazníckou podporou – napr. sťažnosti,
                    reklamácie, podnety, upozornenia.
                </li>
            </ul>
            <p>Informácie získavané v súvislosti s používaním našich služieb a to:</p>
            <ul className="section">
                <li>
                    informácie o vašej interakcii s nami, napríklad akým spôsobom boli využívané služby, spôsob
                    prihlásenia, z akého miesta ste navštívili jednotlivé stránky a ako dlho ste ich používali, reakčné
                    časy, chyby preberania, spôsob získania prístupu k službám a ukončenie ich používania a pod.,
                </li>
                <li>
                    technické údaje používaných zariadení a nastavenia, napríklad IP adresa, nastavenia prehliadača,
                    operačný systém, platforma,{' '}
                    <a href={`${getBaseUrl()}${ROUTES.COOKIES}`} target="_blank" rel="noreferrer">
                        cookies
                    </a>
                    .
                </li>
            </ul>
            <span className="sectionTitle">Prečo spracúvame vaše osobné údaje?</span>
            <p>
                Na to, aby sme mohli vaše osobné údaje spracúvať v súlade so Zákonom, je potrebné, aby sme mali vopred
                stanovený účel ich spracúvania. Nižšie uvádzame účely, na ktoré sú vaše osobné údaje získavané a ďalej
                spracúvané.
            </p>
            <p className="underline">Na spravovanie vášho účtu a poskytovanie našich služieb</p>
            <p>
                <strong>
                    Vo väčšine prípadov je právnym dôvodom, na základe ktorého spracúvame vaše osobné údaje plnenie
                    zmluvy o poskytnutí služby alebo zmluvy o sprostredkovaní služby.
                </strong>{' '}
                Akceptáciou našich podmienok upravujúcich poskytovanie vami zvolenej služby, dochádza teda medzi nami
                k uzatvoreniu zmluvy.
            </p>
            <p className="underline">Na plnenie zákonných povinností</p>
            <p>
                Osobitné právne predpisy nám ako poskytovateľovi služieb môžu ukladať rôzne povinnosti, za účelom
                ktorých je nevyhnutné spracúvanie vašich osobných údajov. Napríklad v súlade s Občianskym zákonníkom a
                predpismi na úseku ochrany spotrebiteľa, spracúvame vaše osobné údaje i za účelom vybavenia prípadných
                reklamácii. Ďalším príkladom, kedy účelom spracúvania osobných údajov je plnenie zákonných povinností
                je zákon o účtovníctve, v zmysle ktorého sme povinní uchovávať určité údaje k plateným službám po dobu
                stanovenú v tomto zákone.
            </p>
            <p>Údaje, ktoré zhromažďujeme v rámci existujúcich služieb, nám pomáhajú pri vývoji nových služieb.</p>
            <p className="underline">Na poskytovanie prispôsobených služieb vrátane obsahu a reklám</p>
            <p>
                Na základe informácii od vás sme schopní pri poskytovaní našich služieb zabezpečiť to, aby vám bola
                poskytnutá služba šitá na „mieru“ vašim potrebám a preferenciám. Poskytujeme vám prispôsobený obsah,
                napr. prostredníctvom zobrazovania relevantných odporúčaných článkov, školení alebo iných podobných
                opatrení, ktoré vám majú uľahčiť využívanie našich služieb a zlepšenie vašej používateľskej skúsenosti
                pri využívaní našich služieb.
            </p>
            <p>
                Cieľom spracovania vašich osobných údajov za týmto účelom je aj zjednodušenie využívania služieb našej
                spoločnosti, napr. školenie na mieru. Informácie, ktoré zhromažďujeme z vašich rôznych zariadení,  nám
                pomáhajú poskytovať konzistentné služby vo všetkých vašich zariadeniach.
            </p>
            <p className="underline">Na zabezpečenie a spravovanie účasti v nami organizovaných súťažiach</p>
            <p>
                V prípade, ak sa rozhodnete zapojiť do spotrebiteľskej súťaže organizovanej našou spoločnosťou a udelíte
                nám za týmto účelom váš súhlas, spracúvame vaše údaje za účelom zabezpečenia a spravovania vašej účasti
                v danej súťaži. Údaje, ktoré za týmto účelom spracúvame závisia od štatútu/podmienok konkrétnej súťaže.
            </p>
            <span className="sectionTitle">
                Aký je právny základ spracovania vašich osobných údajov v zmysle Zákona a Nariadenia?
            </span>
            <p>Zákonnosť spracúvania vašich osobných údajov je u nás odôvodnená nasledovnými právnymi základmi:</p>
            <p>
                V prevažnej miere spracúvame vaše osobné údaje, nakoľko spracúvanie osobných údajov je nevyhnutné na
                plnenie zmluvy, ktorú ste akceptáciou našich podmienok používania, s nami uzatvorili.
            </p>
            <p>
                Medzi ďalšie právne základy patrí plnenie našich zákonných povinností, vaše a naše oprávnené záujmy
                a váš súhlas so spracúvaním osobných údajov. Pokiaľ spracúvame vaše osobné údaje na základe vášho
                súhlasu, tento súhlas ste oprávnený kedykoľvek odvolať.
            </p>
            <span className="sectionTitle">Komu vaše osobné údaje poskytujeme alebo sprístupňujeme?</span>
            <p>
                Z hľadiska Zákona <strong>máme postavenie prevádzkovateľa</strong>, čo znamená, že práve naša spoločnosť
                vymedzuje účely spracovania. V súvislosti s našou činnosťou môžu byť vaše osobné údaje prenášané alebo
                sprístupňované ďalším subjektom, a to či už v postavení samostatného prevádzkovateľa alebo
                sprostredkovateľa. Ako prevádzkovateľ dohliadame na to, aby všetci, ktorým sú vaše osobné údaje
                prenášané, dodržiavali vysoký štandard ich ochrany. V žiadnom prípade neposkytujeme vaše osobné údaje
                subjektu, u ktorého nie je tento štandard zabezpečený.
            </p>
            <p className="underline">Zoznam príjemcov:</p>
            <div className="underline">S-EPI, s.r.o., Martina Rázusa 23A/8336, 010 01 Žilina, IČO: 36 014 991</div>
            <div className="underline">EUROKÓDEX, s.r.o., Martina Rázusa 23A, 010 01 Žilina, IČO: 44 871 384</div>
            <div className="underline">
                ESO9 international a.s., Záběhlice, U Mlýna 2305/22, 141 00  Praha 4, IČO: 27 624 609
            </div>
            <div className="underline">AION CS, s.r.o., nám. T. G. Masaryka 1280, 760 01 Zlín, IČO: 60 738 634</div>
            <div className="underline">Zelená pošta s.r.o., Galvaniho 17/B, 821 04 Bratislava, IČO: 46 529 233</div>
            <div className="underline">
                Západoslovenské tlačiarne Skalica, s.r.o., Mallého 60, 909 01 Skalica, IČO: 35 683 244
            </div>
            <div className="underline">WEBY GROUP s.r.o. Nižovec 2/A, 960 01 Zvolen, IČO: 36 046 884</div>
            <div className="underline">Index Podnikateľa s. r. o., 974 01 Dolná Mičiná 158, IČO 55 970 770</div>
            <p className="underline">Okruhy príjemcov:</p>
            <p>
                Dodávatelia programátorských služieb
                <br />
                Orgány verejnej moci
                <br />
                Subjekty, ktorým poskytnutie vyplýva prevádzkovateľovi priamo zo zákona
            </p>
            <span className="sectionTitle">Ako dlho budú vaše osobné údaje spracúvané? </span>
            <p>
                Spracúvanie vašich osobných údajov prebieha v súlade so zákonnými požiadavkami, čo znamená, že osobné
                údaje neuchovávame dlhšie, ako je nevyhnutné na účel spracúvania. Pokiaľ vaše osobné údaje spracúvame na
                právnom základe – plnenie zmluvy, tak vaše osobné údaje spracúvame
                <strong>po celú dobu trvania zmluvného vzťahu medzi nami</strong>. Ak dôjde k ukončeniu zmluvy
                pristupujeme k likvidácii vašich osobných údajov, pokiaľ nie je možné spracúvať vaše osobné údaje na
                inom právnom základe. Ak ste však počas využívania našich služieb použili i niektoré naše platené
                služby, sme oprávnení naďalej spracúvať údaje týkajúce sa vašich realizovaných platieb pre potreby
                plnenia povinností vyplývajúcich pre nás z daňových a účtovných právnych predpisov.
            </p>
            <p>
                Ak vaše osobné údaje spracúvame na právnom základe – <strong>plnenie zákonných povinností</strong>, tak
                vaše osobné údaje spracúvame po dobu, ktorú určujú právne predpisy. Pokiaľ vaše osobné údaje spracúvame
                na právnom základe – <strong>náš oprávnený záujem alebo oprávnený záujem tretích osôb</strong>, tak vaše
                osobné údaje spracúvame po dobu trvania oprávneného záujmu.
            </p>
            <p>
                V prípade, ak vaše osobné údaje spracúvame na právnom základe – váš súhlas, tak vaše osobné údaje
                spracúvame po dobu, na ktorú ste nám súhlas so spracúvaním vašich osobných údajov udelili, prípadne po
                dobu platnosti účelu spracúvania. Pri spracúvaní osobných údajov za účelom účasti v nami organizovanej
                súťaži na podporu našich produktov alebo služieb, je táto doba uvedená v konkrétom štatúte súťaže alebo
                podmienkach súťaže.
            </p>
            <span className="sectionTitle">Aké máte práva súvisiace s našim spracúvaním vašich osobných údajov?</span>
            <p>
                Zákon ako aj Nariadenie vám poskytuje viaceré práva, ktoré vám umožňujú to, aby ste mali ochranu svojich
                osobných údajov pod vlastnou kontrolou. Naša spoločnosť rešpektuje vaše práva. V tejto sekcii sa preto
                dozviete, aké sú.
            </p>
            <p className="underline">Právo na prístup k osobným údajom</p>
            <p>
                Toto právo znamená, že ste oprávnení žiadať od nás potvrdenie o tom, či sa spracovávajú o vás osobné
                údaje, ktoré sa vás týkajú. Ak teda takéto osobné údaje o vás spracúvame, máte právo získať prístup
                k svojim osobným údajom a informácie o tom:
            </p>
            <ul>
                <li>prečo spracúvame vaše osobné údaje (účel spracovania osobných údajov),</li>
                <li>aké údaje o vás spracúvame (kategória osobných údajov),</li>
                <li>
                    komu môžu resp. budú vaše osobné údaje poskytnuté (identifikácia príjemcov alebo okruhu príjemcov),
                </li>
                <li>ako dlho budeme vaše osobné údaje uchovávať (doba uchovávania osobných údajov),</li>
                <li>
                    že máte právo požadovať od nás opravu osobných údajov, ich vymazanie ako aj obmedzenie ich
                    spracovania alebo že máte možnosť namietať voči spracovaniu osobných údajov,
                </li>
                <li>
                    že máte právo podať návrh na začatie konania o ochrane osobných údajov podľa Zákona alebo právo
                    podať sťažnosť dozornému úradu podľa Nariadenia, ktorým je Úrad na ochranu osobných údajov SR,
                </li>
                <li>
                    odkiaľ pochádzajú vaše osobné údaje (informácie o zdroji), pokiaľ ste nám osobné údaje neposkytli
                    priamo vy,
                </li>
                <li>
                    či využívame automatizované individuálne rozhodovanie vrátane profilovania podľa § 28 ods.
                    1 a 4 Zákona; najmä o použitom postupe, ako aj o význame a predpokladaných dôsledkoch takého
                    spracúvania osobných údajov pre vás,
                </li>
                <li>
                    o primeraných zárukách týkajúcich sa prenosu, v prípade, ak vaše osobné údaje prenášame do tretej
                    krajiny alebo medzinárodnej organizácie.
                </li>
            </ul>
            <p>
                Toto právo na prístup pre vás znamená i možnosť získať osobné údaje, ktoré o vás spracúvame. Poskytneme
                vám kópiu vašich osobných údajov, ktoré o vás spracúvame. Pokiaľ však budete žiadať opakovane
                o poskytnutie svojich osobných údajov, môžeme od vás žiadať primeraný administratívny poplatok
                v súvislosti s vašou žiadosťou o kópiu svojich osobných údajov.
            </p>
            <p className="underline">Právo na opravu osobných údajov</p>
            <p>
                V rámci podmienok poskytovania našich služieb vás informujeme, aby ste nám poskytovali správne údaje. Ak
                sa však napriek tomu stane, že spracúvame o vás nesprávne údaje, právo na opravu osobných údajov
                znamená, že ste oprávnení žiadať, aby sme opravili nesprávne osobné údaje, ktoré sa vás týkajú. Taktiež
                so zreteľom na účel spracovania osobných údajov máte právo aj na to, aby boli doplnené vaše neúplné
                osobné údaje.
            </p>
            <p className="underline">Právo na výmaz osobných údajov (tzv. právo na zabudnutie)</p>
            <p>
                Máte právo na to, aby sme vymazali osobné údaje, ktoré sa vás týkajú ak je splnený aspoň jeden
                z nasledovných dôvodov:
            </p>
            <ul>
                <li>vaše osobné údaje už nie sú potrebné na účel, na ktorý sme ich získali alebo inak spracúvali,</li>
                <li>
                    odvolali ste svoj súhlas so spracovaním osobných údajov, na základe ktorého my spracúvame vaše
                    osobné údaje a zároveň neexistuje iný právny základ pre ich ďalšie spracúvanie,
                </li>
                <li>
                    namietate voči spracúvaniu osobných údajov, ktoré je vykonávané na právnom základe verejného záujmu
                    alebo oprávneného záujmu a neprevažujú žiadne oprávnené dôvody na ich spracúvanie,
                </li>
                <li>vaše osobné údaje sa spracúvali nezákonne,</li>
                <li>
                    vaše osobné údaje musia byť vymazané, nakoľko je nutné splniť povinnosť podľa práva Slovenskej
                    republiky alebo práva Európskej únie,
                </li>
                <li>
                    vaše osobné údaje sa získavali v súvislosti s ponukou služieb informačnej spoločnosti podľa § 15
                    ods. 1 Zákona.
                </li>
            </ul>
            <p>
                Vášmu právu na výmaz osobných údajov však v konkrétnom prípadne s ohľadom na konkrétne okolnosti nemusí
                byť vyhovené, pokiaľ je spracovanie osobných údajov potrebné:
            </p>
            <ul>
                <li>na uplatnenie nášho práva na slobodu prejavu alebo práva na informácie,</li>
                <li>na splnenie zákonnej povinnosti,</li>
                <li>na uplatnenie nášho právneho nároku,</li>
                <li>
                    na účel archivácie, na účel historického výskumu alebo na štatistický účel, pokiaľ je pravdepodobné,
                    že právo na výmaz by nám znemožnilo alebo závažným spôsobom sťažilo dosiahnutie cieľov takého
                    spracúvania.
                </li>
            </ul>
            <p className="underline">Právo na obmedzenie spracúvania osobných údajov</p>
            <p>
                Máte právo na to, aby sme obmedzili spracúvanie osobných údajov, ktoré sa vás týkajú a zároveň je
                splnený aspoň jeden z nasledovných dôvodov:
            </p>
            <ul>
                <li>
                    počas obdobia umožňujúceho nám overenie správnosti vašich osobných údajov napadnete správnosť
                    svojich osobných údajov,
                </li>
                <li>
                    pôjde o nezákonné spracúvanie osobných údajov, namietnete výmaz osobných údajov a budete žiadať
                    namiesto výmazu obmedzenie spracúvania osobných údajov,
                </li>
                <li>
                    my už nebudeme potrebovať vaše osobné údaje na žiadny z účelov spracúvania, alebo budete ich
                    potrebovať vy na preukázanie, uplatňovanie alebo uplatňovanie svojich právnych nárokov,
                </li>
                <li>
                    budete namietať voči spracúvaniu osobných údajov a to až do doby overenia, či naše oprávnené záujmy
                    prevažujú nad vašimi oprávnenými záujmami.
                </li>
            </ul>
            <p className="underline">Právo na prenosnosť osobných údajov</p>
            <p>
                Ak je naše právo na spracúvanie vašich osobných údajov založené na vašom súhlase alebo na plnení
                záväzkov vyplývajúcich zo zmluvy, ktorú sme s vami uzatvorili, máte právo požiadať o prenos údajov,
                ktoré sa vás týkajú a ktoré ste nám poskytli, inému prevádzkovateľovi osobných údajov.
            </p>
            <p className="underline">Právo na odvolanie súhlasu</p>
            <p>
                Pokiaľ spracúvame vaše osobné údaje na právnom základe – súhlas dotknutej osoby, máte právo kedykoľvek
                odvolať tento súhlas a to aj pred uplynutím doby, na ktorú bol tento súhlas udelený.
            </p>
            <p className="underline">
                Právo na neúčinnosť automatizovaného individuálneho rozhodovania vrátane profilovania
            </p>
            <p>
                Máte právo žiadať, aby automatizované individuálne rozhodovania vrátane profilovania bolo voči vám
                neúčinné.
            </p>
            <p className="underline">Právo namieta</p>
            <p>
                Ak máte na to dôvody týkajúce sa vašej konkrétnej situácie, máte právo namietať proti spracúvaniu vašich
                osobných údajov, ak je právnym základom pre také spracúvanie náš oprávnený záujem. Ak však náš oprávnený
                záujem na spracúvanie prevyšuje nad vašim osobným záujmom, môžeme pokračovať v spracúvaní vašich údajov,
                a to aj napriek vašej námietke voči spracúvaniu. Taktiež sme oprávnený pokračovať v spracovaní vašich
                údajov, v prípade, ak je to potrebné pre preukazovanie, uplatňovanie alebo obhajovanie našich právnych
                nárokov.
            </p>
            <p className="underline">Právo odmietnuť odoberanie správ a osobných ponúk na konkrétnych kanáloch</p>
            <p>
                Máte možnosť vzniesť námietku voči spracúvaniu vašich osobných údajov na účely priameho marketingu.
                Námietka sa týka aj analýz osobných údajov (tzv. profilovanie), ktoré sa vykonávajú v súvislosti s
                priamym marketingom.  Ak máte námietky voči priamemu marketingu, prestaneme spracúvať vaše osobné údaje
                na tento účel, ako aj na účel všetkých typov akcií priameho marketingu. Samozrejme, môžete jednoducho
                odmietnuť odoberanie správ a osobných ponúk na konkrétnych kanáloch. Môžete od nás napríklad dostávať
                len ponuky e-mailom, ale nie prostredníctvom SMS správ
            </p>
            <p>
                <strong>Ak ako dotknutá osoba nemáte spôsobilosť na právne úkony v plnom rozsahu</strong>, vaše práva v
                zmysle Nariadenia a Zákona môže uplatniť váš zákonný zástupca. Práva dotknutej osoby, ktorá nežije, môže
                v zmysle Nariadenia a Zákona  uplatniť blízka osoba.
            </p>
            <span className="sectionTitle">Ako nás môžete kontaktovať?</span>
            <p>
                Ak máte akékoľvek otázky týkajúce sa spracovania vašich osobných údajov, môžete nás kontaktovať v
                súvislosti so spracúvaním vašich osobných údajov:
            </p>
            <ul className="section">
                <li>
                    e-mailom na <a href="mailto:zodpovednaosoba@pp.sk">zodpovednaosoba@pp.sk</a>
                </li>
                <li>
                    prostredníctvom pošty na adresu:
                    <strong>
                        Poradca podnikateľa, spol. s r. o., Martina Rázusa 23A, 010 01 Žilina, IČO: 31 592 503
                    </strong>
                    .
                </li>
            </ul>
            <p className="section">
                Ak s našou odpoveďou nebudete spokojní, alebo sa domnievate, že spracovávame vaše údaje nezákonne,
                môžete sa sťažovať na dozorný orgán, ktorým je Úrad na ochranu osobných údajov Slovenskej republiky.
                Ďalšie informácie o dozornom orgáne Slovenskej republiky a postupe podávania sťažností nájdete na jeho
                oficiálnom webovom sídle:
                <a href="https://www.dataprotection.gov.sk" target="_blank" rel="noreferrer">
                    www.dataprotection.gov.sk
                </a>
                .
            </p>
            <span className="title" id={`${COOKIES_CONDITIONS_ID}-sekcia`}>
                PRAVIDLÁ POUŽÍVANIA COOKIES
            </span>
            <p>
                Týmto si vás dovoľujeme informovať o používaní cookies, o účele ich použitia a možnosti nastavenia
                svojho internetového prehliadača v prípade, ak vám aktuálne nastavenie využívania cookies nevyhovuje.
            </p>
            <span className="sectionTitle">Čo sú to cookies?</span>
            <p>
                Cookies sú malé textové súbory, ktoré môžu byť pri návšteve webových stránok odosielané do vášho
                internetového prehliadača a ukladané do vášho zariadenia. Súbory cookies sa ukladajú do priečinka pre
                súbory internetového prehliadača. Cookies zvyčajne obsahujú názov webovej stránky, z ktorej pochádzajú a
                dátum svojho vzniku. Pri ďalšej návšteve danej webovej stránky internetový prehliadač opäť načíta súbory
                cookies a tieto informácie odošle späť webovej stránke, ktorá cookies vytvorila.
            </p>
            <span className="sectionTitle">Aké cookies využívame?</span>
            <p>
                Spoločnosť Poradca podnikateľa, spol. s r. o. používa na svojich webových stránkach nasledovné typy
                súborov cookies:
            </p>
            <p className="underline">Nevyhnutné cookies</p>
            <p>
                Tieto súbory cookies nezhromažďujú informácie a údaje, na základe ktorých je používateľ webovej stránky
                individuálne identifikovateľný, sú ale nevyhnutné pre základnú prevádzku našej webovej stránky. Patria
                sem napríklad cookies, ktoré vám umožňujú prihlásiť sa do svojho konta. Bez týchto cookies nie je možné
                zabezpečovať riadnu prevádzku našej stránky. Pokiaľ nechcete, aby sa tieto cookies ukladali, zmeňte si
                nastavenia prehliadača.
            </p>
            <p className="underline">Funkčné cookies</p>
            <p className="section">
                Tieto súbory cookies umožňujú zapamätať si preferencie používateľa ako napríklad nastavenia zvolené pri
                predchádzajúcej návšteve stránky, užívateľské meno, obľúbené dokumenty atď. pre zlepšenie užívateľského
                komfortu.{' '}
                <a
                    onClick={() =>
                        router.push({
                            pathname: router.pathname,
                            query: {
                                ...router.query,
                                updateCookies: true,
                            },
                        })
                    }
                >
                    Zmena nastavenia cookies.
                </a>
            </p>
            <p className="underline">Štatistické cookies</p>
            <p>
                Tieto súbory cookies nám pomáhajú porozumieť tomu, ako návštevníci interagujú s webovými stránkami
                anonymným zhromažďovaním a oznamovaním informácií, a tým zlepšovať naše stránky.
            </p>
            <p className="underline">Marketingové cookies</p>
            <p>
                Tieto súbory cookies sa používajú za účelom poskytovania a zobrazovania reklamy na základe záujmov
                používateľov webových stránok alebo zhromažďovania osobných údajov od nich na budúce marketingové účely.
                Na základe aj týchto súborov je pre nás možné relevantnejšie a efektívnejšie cieliť priamu marketingovú
                komunikáciu, ale aj obmedziť počet zobrazení reklamy.
            </p>
            <p className="underline">Analytické cookies</p>
            <p>
                Tieto súbory cookies slúžia na získanie údajov o návštevnosti webovej stránky, identifikujú pôvod
                návštevy a tiež zisťujú a zbierajú informácie o tom, ako využíva návštevník túto webovú stránku. Slúžia
                na zlepšovanie a zjednodušenie užívateľského rozhrania stránky.
            </p>
            <span className="sectionTitle">Za akým účelom cookies využívame?</span>
            <p>
                Súbory cookies umožňujú našej webovej stránke rozpoznať vaše zariadenie a zapamätať si určité informácie
                o vás a vašich aktivitách vykonaných počas pripojenia na našu webovú stránku. Cookies používame s cieľom
                optimálne vytvárať a neustále skvalitňovať naše služby, prispôsobiť ich vašim záujmom a potrebám a
                zlepšovať ich štruktúru a obsah.
            </p>
            <span className="sectionTitle">Môžem si zmeniť nastavenie súborov cookies?</span>
            <p>
                Používanie cookies a ich povolenie vo webovom prehliadači je na vašom rozhodnutí. Je potrebné však
                pamätať na to, že v prípade zmeny ich nastavenia môže dôjsť k obmedzeniu funkčnosti webovej stránky a k
                zníženiu užívateľského komfortu.
            </p>
            <span className="title" id={`${MARKETING_CONDITIONS_ID}-sekcia`} style={{ paddingTop: '25px' }}>
                SÚHLAS SO ZASIELANÍM MARKETINGOVÝCH PONÚK
            </span>
            <p>
                <strong>Prihlásením sa k odberu marketingových ponúk vyjadrujete svoj súhlas</strong>  s tým, aby vám
                prevádzkovateľ  Poradca podnikateľa, spol. s r. o., Martina Rázusa 23A, 010 01 Žilina, IČO:
                31 592 503 (ďalej len „prevádzkovateľ“) zasielal marketingové ponuky prevádzkovateľa a tretích strán
                (napríklad firmy v rámci skupiny podnikov PP).
            </p>
            <p>
                <strong>Právnym základom spracúvania</strong> osobných údajov na uvedený účel je súhlas dotknutej osoby
                v zmysle čl. 6 ods. 1 písm. a) Nariadenia Európskeho parlamentu a Rady (EÚ) 2016/679 z 27. apríla 2016 o
                ochrane fyzických osôb pri spracúvaní osobných údajov a o voľnom pohybe takýchto údajov, ktorým
                sa zrušuje smernica 95/46/ES (všeobecné nariadenie o ochrane údajov). Dotknutá osoba má právo svoj
                súhlas kedykoľvek odvolať bez toho, aby to malo vplyv na zákonnosť spracúvania založeného na súhlase
                udelenom pred jeho odvolaním.
            </p>
            <p>
                <strong>Čas platnosti súhlasu uplynie po 5 rokoch odo dňa</strong> posledného poskytnutia služieb alebo
                tovaru alebo prihlásenia sa k odberu marketingových ponúk. Osobné údaje budú poskytované príjemcom,
                ktorými sa rozumejú  kuriérske spoločnosti a Zelená pošta s.r.o., Galvaniho 17/B, 821 04 Bratislava,
                IČO: 46 529 233, ako aj Slovenská obchodná inšpekcia, Daňový úrad a iné subjekty osobitných predpisov.
                Osobné údaje budú poskytované aj príjemcom S-EPI, s.r.o., Martina Rázusa 23A/8336, 010 01 Žilina, IČO:
                36 014 991, EUROKÓDEX, s.r.o., Martina Rázusa 23A, 010 01 Žilina a ESO9 international a.s., Záběhlice, U
                Mlýna 2305/22, 141 00  Praha 4, IČO: 27 624 609.
            </p>
            <p>
                <strong>Osobné údaje nebudú poskytované do tretej krajiny</strong> alebo medzinárodnej organizácii.
                V záujme prispôsobovania marketingových ponúk vašim individuálnym potrebám bude prevádzkovateľ
                na základe histórie vašich objednávok vytvárať personalizované marketingové ponuky. Na vytváranie
                personalizovaných marketingových ponúk bude využívať súbory cookies a nástroj google analytics.
            </p>
            <p>
                V súvislosti so spracúvaním osobných údajov si vás súčasne dovoľujeme upozorniť na to, že poskytnutím
                osobných údajov našej spoločnosti nadobúdate postavenie dotknutej osoby, ktorá má právo na prístup k
                osobným údajom, právo na opravu, vymazanie alebo obmedzenie
            </p>
            <p>
                spracúvania osobných údajov, právo na prenosnosť údajov, právo namietať proti spracúvaniu osobných
                údajov (vrátane profilovania) a právo na to, aby sa na ňu nevzťahovalo rozhodnutie založené výlučne
                na automatizovanom spracúvaní (vrátane profilovania). Dotknutá osoba má súčasne právo podať sťažnosť
                orgánu dozoru, ktorým je Úrad na ochranu osobných údajov Slovenskej republiky. Prevádzkovateľ vyhovie
                každej oprávnenej  žiadosti dotknutej osoby v rozsahu, v akom to bude technicky možné.
            </p>
            <p className="section">
                Prípadné otázky týkajúce sa ochrany osobných údajov adresujte zodpovednej osobe prevádzkovateľa
                prostredníctvom e-mailovej adresy <a href="mailto:zodpovednaosoba@pp.sk">zodpovednaosoba@pp.sk</a>.
            </p>
        </Wrapper>
    );
};

export default GdprConditionsTemplate;
